module.exports = __webpack_public_path__ + "static/media/vis17.18d00f38.jpeg";